// extracted by mini-css-extract-plugin
module.exports = {"icon":"template-link-copy_icon__3YTnM"};